import { forwardRef } from "react";

import type { IFastButtonProps } from "@components/fastFields/fastButton/types";
import { Button } from "@components/molecules/button";
import { fastButtonVariants } from "@components/fastFields/fastButton/variants";
import { useParseTranslationString } from "@/hooks/useParseTranslationString";

export const FastButton = forwardRef<HTMLButtonElement, IFastButtonProps>(
  ({ type, label: propsLabel, entityName, ...restButtonProps }, ref) => {
    const { parseTranslatableString } = useParseTranslationString([
      "action",
      "entity",
      "page",
    ] as const);

    const { label: variantsLabel, ...variantProps } =
      fastButtonVariants(entityName)[type];

    const label = propsLabel || variantsLabel;

    return (
      <Button
        label={parseTranslatableString(label)}
        {...variantProps}
        {...restButtonProps}
        ref={ref}
      />
    );
  },
);

FastButton.displayName = "FastButton";
